import { render, staticRenderFns } from "./CourseConnectionWebsocket.vue?vue&type=template&id=3d88c572&scoped=true&"
import script from "./CourseConnectionWebsocket.vue?vue&type=script&lang=js&"
export * from "./CourseConnectionWebsocket.vue?vue&type=script&lang=js&"
import style0 from "./CourseConnectionWebsocket.vue?vue&type=style&index=0&id=3d88c572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88c572",
  null
  
)

export default component.exports